import { FormInstance } from "antd";
import { WAN } from "Utility/Types/status_identity_get_set";

export const setProtocolOption = (wan: WAN) => {
  // SET profileInterface
  let table: any = {};
  wan?.connect_table?.profile.forEach((item: any, index: number) => {
    table[`Table${index + 1}`] = item?.profile_list;
  });

  const profileInterfaceObj: any = {};
  table["Table1"]?.forEach((item: any, index: number) => {
    let key = JSON.stringify(["Table1", index, "interface"]);
    profileInterfaceObj[key] = item.interface;
  });
  table["Table2"]?.forEach((item: any, index: number) => {
    let key = JSON.stringify(["Table2", index, "interface"]);
    profileInterfaceObj[key] = item.interface;
  });
  table["Table3"]?.forEach((item: any, index: number) => {
    let key = JSON.stringify(["Table3", index, "interface"]);
    profileInterfaceObj[key] = item.interface;
  });

  return profileInterfaceObj;
};

export const setFields = (wan: WAN, form: FormInstance<any>) => {
  form.setFieldsValue({
    WAN_ipv4_type_1: wan?.ethernet?.dhcp?.dns.ipv4[0].type || "ISP",
    WAN_ipv4_address_1: wan?.ethernet?.dhcp?.dns.ipv4[0].address,
    WAN_ipv4_type_2: wan?.ethernet?.dhcp?.dns.ipv4[1].type || "ISP",
    WAN_ipv4_address_2: wan?.ethernet?.dhcp?.dns.ipv4[1].address,
    WAN_ipv4_type_3: wan?.ethernet?.dhcp?.dns.ipv4[2].type || "ISP",
    WAN_ipv4_address_3: wan?.ethernet?.dhcp?.dns.ipv4[2].address,
    WAN_username: wan?.ethernet?.pppoe?.username,
    WAN_service_name: wan?.ethernet?.pppoe?.service_name,
    WAN_priority_1: wan?.priority?.order[0] || "lte",
    WAN_priority_2: wan?.priority?.order[1] || "eth",
    WAN_priority_3: wan?.priority?.order[2] || "wifi-2.4G",
    WAN_lte_mode: wan?.priority?.lte?.mode,
    WAN_ethernet_type: wan?.ethernet?.type || "dhcp",
    WAN_static_ipv4_address: wan?.ethernet?.static?.ipv4?.address,
    WAN_static_ipv4_dns_address1: wan?.ethernet?.static?.ipv4?.dns?.[0]?.address,
    WAN_static_ipv4_dns_address2: wan?.ethernet?.static?.ipv4?.dns?.[1]?.address,
    WAN_static_ipv4_dns_address3: wan?.ethernet?.static?.ipv4?.dns?.[2]?.address,
    WAN_static_gateway: wan?.ethernet?.static?.ipv4?.gateway,
    WAN_static_netmask: wan?.ethernet?.static?.ipv4?.netmask,
    active_profile: wan?.connect_table?.active_profile,
    profile_name_1: wan?.connect_table?.profile?.[0]?.profile_name,
    profile_name_2:
      wan?.connect_table?.profile?.[1]?.profile_name === "" ? " " : wan?.connect_table?.profile?.[1]?.profile_name,
    profile_name_3:
      wan?.connect_table?.profile?.[2]?.profile_name === ""
        ? "profile_name"
        : wan?.connect_table?.profile?.[2]?.profile_name,
    Table1: wan?.connect_table?.profile?.[0]?.profile_list,
    Table2: wan?.connect_table?.profile?.[1]?.profile_list,
    Table3: wan?.connect_table?.profile?.[2]?.profile_list,
  });

  if (wan?.priority?.order.length === 1) {
    //if xxx only, then 2dn 3th value may be duplicated with the first one
    if (wan?.priority?.order[0] === "lte") {
      form.setFieldsValue({
        WAN_priority_2: "eth",
        WAN_priority_3: "wifi-2.4G",
      });
    } else if (wan?.priority?.order[0] === "eth") {
      form.setFieldsValue({
        WAN_priority_2: "lte",
        WAN_priority_3: "wifi-2.4G",
      });
    } else if (wan?.priority?.order[0] === "wifi-2.4G") {
      form.setFieldsValue({
        WAN_priority_2: "eth",
        WAN_priority_3: "lte",
      });
    }
  }
};
